import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
}

/**
 * Bloque de carga con animación.
 * Se usa para reservar el espacio de los datos mientras llegan, evitando saltos
 * de layout (CLS).
 */
export function Skeleton({ className }: SkeletonProps) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-lg bg-ink-100', className)} />;
}
